import {LitElement, html, nothing} from "lit";
import {customElement, property} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";

import {labeledTextInputStyles} from "./LabeledTextInput.styles.js";

@customElement("pn-labeled-text-input")
export class LabeledTextInput extends LitElement {
	static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

	static styles = [labeledTextInputStyles];

	@property() autocomplete: string;
	@property() className:    string;
	@property() editable = true;
	@property() error:        string | boolean = false;
	@property() id:           string;
	@property() inputType = "text";
	@property() isLabelBold = false;
	@property() label:        string;
	@property() maxLength:    number;
	@property() onKeydown:    (event: KeyboardEvent) => void;
	@property() onInput:      (event: InputEvent) => void;
	@property() placeholder = "";
	@property() required = false;
	@property() value:        string | number | boolean;

	isError() {
		return typeof this.error === "string"
			? (this.error !== "" && this.error !== "false")
			: this.error;
	}

	renderErrorMessage() {
		if (!(this.isError() && this.required))
			return nothing;

		let message = "Required";
		if (typeof this.error === "string")
			message = this.error;

		return html`
			<span
				class="error-message"
				part="error"
				role="alert"
			>${message}</span>
		`;
	}

	render() {
		const finalLabel = this.required ? `${this.label} *` : this.label;

		return html`<label
			class="${classMap({
				[this.className]: this.className ?? nothing,
				"is-bold":        this.isLabelBold
			})}"
			id="${this.id ?? nothing}"
			part="label"
		>
			<span class="input-label-text">${finalLabel}</span>
			${this.renderErrorMessage()}

			<input
				autocomplete=${this.autocomplete ?? nothing}
				class="${classMap({
					error: this.isError() && this.required
				})}"
				id="${this.id ? `${this.id}-input` : nothing}"
				@input=${this.onInput}
				@keydown=${this.onKeydown}
				maxLength="${this.maxLength ?? nothing}"
				part="input"
				placeholder="${this.placeholder}"
				?readonly="${!this.editable}"
				type="${this.inputType}"
				value="${this.value ?? nothing}"
			/>
		</label>`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-labeled-text-input": LabeledTextInput;
	}
}
